import React, { Dispatch, SetStateAction } from 'react';
import { BRAND, isMarketGB } from 'src/constants/main';
import { SummaryOptionsStyledAC } from './AC/SummaryOptionsStyled.AC';
import { SummaryOptionsStyledOV } from './OV/SummaryOptionsStyled.OV';
import { SummaryOptionsStyledAP } from './AP/SummaryOptionsStyled.AP';
import { SummaryOptionsStyledDS } from './DS/SummaryOptionsStyled.DS';
import { SummaryOptionsStyledOV as SummaryOptionsOV_GB } from './OV/GB/SummaryOptionsStyled.OV';
import { SummaryOptionsStyled } from './SummaryOptionsStyled';
import { SC } from 'src/styles/theme';

export type SummaryOptionsProps = SC & {};

const SummaryOptions = (props: SummaryOptionsProps) => {
    if (BRAND === 'AC') return <SummaryOptionsStyledAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <SummaryOptionsOV_GB {...props} /> : <SummaryOptionsStyledOV {...props} />;
    if (BRAND === 'AP') return <SummaryOptionsStyledAP {...props} />;
    if (BRAND === 'DS') return <SummaryOptionsStyledDS {...props} />;
    return <SummaryOptionsStyled {...props} />;
};

export default SummaryOptions;
